import React, { useEffect, useState } from "react";
import "./VerifyEmail.css";
import LoginLogo from "../../Components/Assets/images/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { useTitle } from "../../hooks/useTitle";

function ResetConfirmation() {
  useTitle("Change Confirmed - TrendBay DS");
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  useEffect(() => {
    const originalColor = document
      .querySelector("meta[name='theme-color']")
      ?.getAttribute("content");
    const metaThemeColor = document.querySelector("meta[name='theme-color']");
    if (metaThemeColor) metaThemeColor.setAttribute("content", "#ffffff");
    return () => {
      if (metaThemeColor && originalColor) {
        metaThemeColor.setAttribute("content", originalColor);
      }
    };
  }, []);

  return (
    <div className="ve">
      <a href="/">
        <img className="ve__logo" src={LoginLogo} alt="TrendBay" />
      </a>

      <div className="ve_container">
        <p style={{ fontSize: "15px" }}>
          Redirecting in 10 <br />
          <br />
          <small>You can now log in with your new password.</small>
        </p>
        <a href="/login">
          <button className="ve_signInButton mb-3">Go to Login</button>
        </a>
      </div>
    </div>
  );
}

export default ResetConfirmation;
